enum AppRoutes {
    Landing = '',
    Changeover = 'changeover',
    ChangeoverReview = 'changeover/review',
    LineSetup = 'line/setup',
    LineSchedule = 'line/schedule',
    LineScheduleAdd = 'line/schedule/add',
    ResetDB = 'reset',
}

export default AppRoutes;

export const getRouteParts = (value: AppRoutes) => value.split('/');
